import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { MobileHeader } from "@/components/MobileHeader";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { useIsMobile } from "@/hooks/use-mobile";

interface CustomerLayoutProps {
  children: ReactNode;
}

export function CustomerLayout({ children }: CustomerLayoutProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="min-h-screen bg-background">
        <main className="pb-16">
          {children}
        </main>
        <MobileBottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <h1 className="text-2xl font-bold text-primary">
                🚀 Money+ E Wallet
              </h1>
            </Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/auth" className="text-muted-foreground hover:text-primary transition-colors">
                เข้าสู่ระบบ
              </Link>
            </nav>
          </div>
        </div>
      </header>
      <main>
        {children}
      </main>
      <footer className="border-t bg-card/50 mt-auto">
        <div className="container mx-auto px-4 py-6">
          <div className="text-center text-sm text-muted-foreground">
            © 2025 Money+ E Wallet. ระบบ E-Wallet ครบวงจร
          </div>
        </div>
      </footer>
    </div>
  );
}